import React, { Component } from 'react';
import { Link } from 'react-router';
import Promise from 'bluebird';
import config from 'cfg';
import styled from 'styled-components';
import CopyToClipboard from 'react-copy-to-clipboard';
import { List, ListItem, Divider, Snackbar, FlatButton } from 'material-ui';
import ContentCopy from 'material-ui/svg-icons/content/content-copy';
import Forward from 'material-ui/svg-icons/content/forward';
import moment from 'moment';
import _ from 'lodash';

const Wrapper = styled.div`
    margin: 0 auto 10px;
    max-width: 1170px;
`;
const TeamItem = styled.div`
    border-left: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;

    > div > span > div > div {
        padding: 0 !important;
    }

    a {
        padding: 16px;
        span {
            flex: 0 1 50%;

            &.id {
                flex: 0 1 30%;
                text-align: right;
            }
        }
    }
`;

export default class IDSTournament extends Component {
    componentDidMount() {
        Promise.props({
            finishedEvents: fetch(
                `${config.apis.ss2}/events-v2?ttId=${this.props.params.tournamentId}&status=finished&limit=${this.state
                    .limit}&sortDirection=desc`
            ).then(response => response.json()),
            notstartedEvents: fetch(
                `${config.apis.ss2}/events-v2?ttId=${this.props.params.tournamentId}&status=notstarted&limit=${this
                    .state.limit}&sortDirection=asc`
            ).then(response => response.json()),
            teams: fetch(`${config.apis.ss2}/tournaments/${this.props.params.tournamentId}/teams`).then(response =>
                response.json()
            )
        }).then(res => {
            this.setState({
                finishedEvents: res.finishedEvents.events,
                notstartedEvents: res.notstartedEvents.events,
                teams: res.teams
            });
        });
    }

    state = {
        tournament: {},
        limit: 10,
        open: false
    };

    handleTouchTap = () => {
        this.setState({
            open: true
        });
    };

    handleRequestClose = () => {
        this.setState({
            open: false
        });
    };

    renderLastEvents() {
        const { finishedEvents } = this.state;
        const sortedEvents = _.sortBy(finishedEvents, 'startDate');

        return (
            <div>
                <h3>Last matches</h3>
                {this.getEvents(sortedEvents)}
            </div>
        );
    }

    renderComingEvents() {
        const { notstartedEvents } = this.state;
        const sortedEvents = _.sortBy(notstartedEvents, 'startDate');

        return (
            <div>
                <h3>Coming matches</h3>
                {this.getEvents(sortedEvents)}
            </div>
        );
    }

    renderTeams() {
        const { teams } = this.state;

        if (!teams) return null;

        const sportType = this.props.params.sport; //soccer

        const btnsPositioning = {
            right: 0,
            marginRight: 16,
            position: 'absolute',
            transform: 'translateY(-50%)',
            top: '50%'
        };

        const snackbarStyle = {
            textAlign: 'center'
        };

        const styleLink = {
            display: 'flex',
            textDecoration: 'none',
            color: 'inherit',
            cursor: 'pointer',
            fontSize: '.875rem'
        };

        let teamsNames = teams.map(item => {
            const teamUrl = `/ids-finder/${sportType}/teams/${item.id}`;

            return (
                <TeamItem key={item.id}>
                    <ListItem>
                        <Link to={teamUrl} style={styleLink}>
                            <span>{item.name}</span>
                            <span className="id">{item.id}</span>
                        </Link>
                        <CopyToClipboard text={item.id}>
                            <div>
                                <div style={btnsPositioning}>
                                    <FlatButton
                                        label="Copy"
                                        primary
                                        icon={<ContentCopy />}
                                        onClick={this.handleTouchTap}
                                    />
                                    <Link to={teamUrl}>
                                        <FlatButton primary icon={<Forward />} />
                                    </Link>
                                </div>
                                <Snackbar
                                    open={this.state.open}
                                    message="ID copied to clipboard"
                                    autoHideDuration={3000}
                                    onRequestClose={this.handleRequestClose}
                                    contentStyle={snackbarStyle}
                                />
                            </div>
                        </CopyToClipboard>
                    </ListItem>
                    <Divider />
                </TeamItem>
            );
        });

        return (
            <List>
                <h3>Teams</h3>
                <Divider />
                {teamsNames}
            </List>
        );
    }

    getEvents(event) {
        if (!event) return null;

        const btnsPositioning = {
            right: 0,
            marginRight: 16,
            position: 'absolute',
            transform: 'translateY(-50%)',
            top: '50%'
        };
        const snackbarStyle = {
            textAlign: 'center'
        };
        const listStyle = {
            display: 'flex',
            justifyContent: 'space-between',
            color: 'inherit',
            fontSize: '.875rem',
            borderLeft: '1px solid #E0E0E0',
            borderRight: '1px solid #E0E0E0'
        };
        const spanStyle = {
            flex: '0 1 calc(100% / 3)'
        };

        let eventsList = event.map(ev => {
            let date = moment(ev.startDate).format('DD. MMM. YYYY - HH:mm');

            return (
                <div key={ev.eventId}>
                    <ListItem disabled style={listStyle}>
                        <span style={spanStyle}>{date}</span>
                        <span style={spanStyle}>
                            {ev.homeName} &ndash; {ev.awayName}
                        </span>
                        <span style={spanStyle}>
                            {ev.statusType === 'finished' ? `${ev.score.home} - ${ev.score.away}` : null}
                        </span>
                        <span style={spanStyle}>{ev.eventId}</span>
                        <CopyToClipboard text={ev.eventId}>
                            <div>
                                <div style={btnsPositioning}>
                                    <FlatButton
                                        label="Copy"
                                        primary
                                        icon={<ContentCopy />}
                                        onClick={this.handleTouchTap}
                                    />
                                </div>
                                <Snackbar
                                    open={this.state.open}
                                    message="ID copied to clipboard"
                                    autoHideDuration={3000}
                                    onRequestClose={this.handleRequestClose}
                                    contentStyle={snackbarStyle}
                                />
                            </div>
                        </CopyToClipboard>
                    </ListItem>
                    <Divider />
                </div>
            );
        });

        return (
            <List>
                <Divider />
                {eventsList}
            </List>
        );
    }

    render() {
        const { finishedEvents } = this.state;

        if (!finishedEvents) return null;

        let tournamentName = finishedEvents[0].tournamentName;
        let country = finishedEvents[0].country;

        return (
            <div>
                <h2 style={{ textAlign: 'center' }}>
                    {country} {tournamentName}
                </h2>
                <Wrapper>
                    {this.renderTeams()}
                    {this.renderLastEvents()}
                    {this.renderComingEvents()}
                </Wrapper>

                <div>{this.props.children}</div>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/ids-finder/IDSTournament.js
 **/